import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { TimelineActionPopupComponent } from './components/timeline-action-popup/timeline-action-popup.component';
import { TimelineListComponent } from './components/timeline-list/timeline-list.component';
import {
	TimelineEffects,
	TimelineFeatureKey,
	timelineReducers,
	TimelineSelector,
} from './store';
import { TimelineAdapter } from './timeline.adapter';

@NgModule({
	declarations: [TimelineListComponent, TimelineActionPopupComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		FormsModule,
		StoreModule.forFeature(TimelineFeatureKey, timelineReducers),
		EffectsModule.forFeature([TimelineEffects]),
		DxDataGridModule,
		NgOptimizedImage,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcAvatarModule,
		DcBadgeModule,
		DcBreadcrumbModule,
		DcPopoverModule,
		DcButtonModule,
	],
	providers: [TimelineAdapter, TimelineSelector],
})
export class TimelineModule {
	public constructor(private readonly injector: Injector) {
		const timelineListCmpElement = createCustomElement(TimelineListComponent, {
			injector,
		});
		customElements.define('app-timeline-list', timelineListCmpElement);
	}
}
